"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LocalityState = {
  ACT: {
    ahStateId: 8,
    name: 'Australian Capital Territory',
    abbreviation: 'ACT'
  },
  NSW: {
    ahStateId: 1,
    name: 'New South Wales',
    abbreviation: 'NSW'
  },
  NT: {
    ahStateId: 7,
    name: 'Northern Territory',
    abbreviation: 'NT'
  },
  QLD: {
    ahStateId: 3,
    name: 'Queensland',
    abbreviation: 'QLD'
  },
  SA: {
    ahStateId: 4,
    name: 'South Australia',
    abbreviation: 'SA'
  },
  TAS: {
    ahStateId: 6,
    name: 'Tasmania',
    abbreviation: 'TAS'
  },
  VIC: {
    ahStateId: 2,
    name: 'Victoria',
    abbreviation: 'VIC'
  },
  WA: {
    ahStateId: 5,
    name: 'Western Australia',
    abbreviation: 'WA'
  }
};
var _default = exports.default = LocalityState;